<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="resetTitle">重置密码</span>
      <p class="hintMsg">请发送验证码到手机{{ smsTo }}</p>
    </div>
    <div class="inputBody">
      <el-form :model="resetPasswordForm" :rules="resetPasswordFormRules" ref="resetPasswordForm">
        <el-form-item label="" prop="phoneCaptcha">
          <el-input v-model="resetPasswordForm.phoneCaptcha" placeholder="手机验证码">
            <el-button slot="append" type="primary">获取验证码</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="newPassword">
          <el-input type="password" :show-password="true" v-model="resetPasswordForm.newPassword" placeholder="请输入新密码"/>
        </el-form-item>
        <el-form-item label="" prop="reEnterPassword">
          <el-input type="password" :show-password="true" v-model="resetPasswordForm.reEnterPassword" placeholder="请再次输入新密码"/>
        </el-form-item>
        <el-form-item>
          <div class="resetSubmit">
            <el-button class="resetButton" type="primary" @click="resetPassword('resetPasswordForm')"
                       :loading="loginLoading">确 定
            </el-button>
            <el-link type="primary" href="/login">使用已有账户登录</el-link>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "ResetPassword",
  data() {
    return {
      resetPasswordForm: {
        phoneCaptcha: '',
        newPassword: '',
        reEnterPassword: ''
      },
      smsTo: '1888888',
      loginLoading: false,
      resetPasswordFormRules: {
        phoneCaptcha: [
          {required: true, message: '请输入手机验证码！', trigger: 'blur'},
        ],
        newPassword: [
          {required: true, message: '请输入新密码！', trigger: 'blur'},
        ],
        reEnterPassword: [
          {required: true, message: '请输入再次输入新密码！', trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    resetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            type: "success",
            message: "重置成功"
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">

.clearfix {
  .resetTitle {
    font-size: 16px;
    font-weight: bold;
  }

  .hintMsg {
    margin-top: 10px;
    font-size: 12px;
    color: gray;
  }
}

.inputBody {

  .resetSubmit {
    margin-top: 54px;
    display: flex;
    justify-content: space-between;

    .resetButton {
      padding: 12px 50px;
    }
  }
}

</style>